module.exports = __webpack_public_path__ + "static/media/connect.eb28df66.png";